import { useEffect, useState, useRef, useContext, createContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

import styles from "./Hub.module.css"
import guestii from '../../assets/images/logos/guestii.svg'
import guestii_gif from '../../assets/images/guestii_gif.gif'


const RatingsPage = ({ toggledMenu, indEvent, setIsLoading, isLoading, setShowRatings }) => {
	const [hovered, setHovered] = useState(null);
	const [currentRating, setCurrentRating] = useState(null);
	const [editMade, setEditMade] = useState(false)


	useEffect(() => {
		const handleLoad = async () => {
			const userId = localStorage.getItem("_id")
			const expiry = localStorage.getItem("expiry")
			if (!userId || !expiry) {
				locationStorage.removeItem("_id")
				locationStorage.removeItem("expiry")
				window.location = "/connect"
			}

			try {
				setIsLoading(true)
				const retrieve = await axios.get(`/api/hub/get-guestii-rating/${userId}/${toggledMenu._id}/${indEvent._id}`);
				setCurrentRating(retrieve.data.rating ? retrieve.data.rating.toString() : null)
				setIsLoading(false)
			} catch (e) {
				localStorage.removeItem("_id")
				localStorage.removeItem("expiry")
				window.location = "/connect"
			}
		}

		handleLoad()
	}, [])

	const handleClose = () => {
		setCurrentRating(null)
		setEditMade(false)
		setShowRatings(false)
	}

	const handleRateGuestii = async (control, i?) => {
		switch (control) {
			case 'set':
				setCurrentRating(i)
				setEditMade(true)
				break;
			case 'submit':
				const userId = localStorage.getItem("_id")
				if (!userId) {
					locationStorage.removeItem("_id")
					locationStorage.removeItem("expiry")
					window.location = "/connect"
				}

				await axios.post(`/api/hub/rate-guestii/${userId}`, {
					rating: parseInt(currentRating),
					event: indEvent._id,
					guestii: toggledMenu._id
				});

				handleClose()
				break;
		}
	}

	return (
		<div className={`${styles.popup_container_ind} ${isLoading && styles.popup_setheight}`}>
			{!isLoading
				?
					<div className={styles.ratings_layout}>
						<button className={styles.ind_close_ind} onClick={handleClose}><i className={`fa-solid fa-xmark ${styles.s1}`}></i></button>

						<div className={styles.new_banner}>
							<div className={styles.new_title}>
								<p className={styles.bold}>Set Guestii Rating</p>
								<p className={styles.s1}>Choose a rating between 1-5 for this Guestii</p>
							</div>

							<div className={styles.banner_progress}>
								<div className={`${styles.progress_circle} ${styles.progress_circle_active}`}>
									<i className={`fa-solid fa-star ${styles.m1}`}></i>
								</div>
							</div>
						</div>

						<div className={styles.ratings_form_container}>
							<div className={styles.ratings_warning}>
								<p className={styles.s1}>Ratings are event specific. Guestiis page shows all ratings.</p>
							</div>

				            <div className={styles.reviewContainer} onMouseLeave={() => setHovered(null)} >
				            	{Array.from({ length: 5 }).map((s, i) => {
				            		const isFilled = hovered !== null && i+1 <= hovered
				            		const isRated = currentRating !== null && i+1 <= currentRating
				            		
				            		return (
										<button
											id={i}
											className={styles.starContainer}
											onMouseEnter={() => setHovered(i+1)}
											onClick={() => handleRateGuestii("set", i+1)}
										>
											<i className={`fa-${isRated ? 'solid' : isFilled ? 'solid' : 'regular'} fa-star ${styles.xl3}`}></i>
										</button>
				            		)
				            	})}
				            </div>
						</div>

						<div className={styles.control_container}>
							<button disabled={!editMade} onClick={() => handleRateGuestii('submit')} className={`${styles.control_btn} ${styles.next_btn}`} style={!editMade ? { visibility: "hidden" } : { visibility: 'visible' }}>
								<i className={`fa-solid fa-check ${styles.m1}`}></i>
							</button>
						</div>
					</div>
				:
			        <div className={styles.loading_layout}>
			            <img src={guestii_gif}/>
			        </div>
			}
		</div>
	)
}


const Ratings = ({ indEvent, setShowRatings, toggledMenu }) => {
	const [isLoading, setIsLoading] = useState(false);

	return (
		<RatingsPage {... { toggledMenu, indEvent, setIsLoading, isLoading, setShowRatings } }/>
	);
};

export default Ratings;